import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import { Loadable } from '../base/components/Lodable.tsx'

const RegistroApp = Loadable(lazy(() => import('./view/./Registro.tsx')))
const GestionVentaApp = Loadable(lazy(() => import('./view/GestionVenta')))
const GestionFacturaApp = Loadable(lazy(() => import('./view/GestionFacturas')))

/**
 * Mapa de rutas
 */
export const ventaRoutesMap = {
  registro: {
    path: '/venta/registro',
    name: 'Registrar Venta',
  },
  registroCredito: {
    path: '/venta/registroCredito',
    name: 'Registrar Venta Crédito',
  },
  gestionVenta: {
    path: '/venta/gestion',
    name: 'Gestion de ventas',
  },
  gestionFactura: {
    path: '/venta/facturas',
    name: 'Gestion de Facturas',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const ventaRoutes = [
  {
    path: ventaRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <RegistroApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: ventaRoutesMap.gestionVenta.path,
    element: <GestionVentaApp />,
    auth: authRoles.admin,
  },
  {
    path: ventaRoutesMap.gestionFactura.path,
    element: <GestionFacturaApp />,
    auth: authRoles.admin,
  },
]

export default ventaRoutes
